namespace $.$$ {

	export class $shm_wordstat_task_list extends $.$shm_wordstat_task_list {

		filter_text( value: string ) {
			return String( value ).replaceAll( '\\', '\\\\' ).replaceAll( '"', '\\"' )
		}

		user_id() {
			return this.$.$shm_ba_pb.user_id()
		}

		new_task_id() {
			return 'new'
		}

		task_records() {
			const user = this.user_id()
			if( !user ) return [] as readonly $shm_ba_pb_file_record[]
			const date = this.List_head().sort_by() === 'updated' ? 'updated' : 'created'
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`wordstat_tasks\nuser = "${ this.filter_text( user ) }"\n-${ date },title\n1\n200\nid,user,title,sort,created,updated`,
				`wordstat_tasks/user:${ user }:list`,
				record => String( record.user || '' ) === user,
			)
		}

		tasks() {
			const date = this.List_head().sort_by() === 'updated' ? 'updated' : 'created'
			return this.task_records()
				.toSorted( ( left, right )=> {
					const left_date = Date.parse( String( left[ date ] || left.created || '' ) ) || Number( left.sort || 0 )
					const right_date = Date.parse( String( right[ date ] || right.created || '' ) ) || Number( right.sort || 0 )
					const changed = right_date - left_date
					if( changed ) return changed
					return String( left.title ?? '' ).localeCompare( String( right.title ?? '' ) )
				} )
				.map( record => ({
					id: record.id,
					title: String( record.title || record.id ),
				}) )
		}

		task_id( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'wordstat_task', next || null )
				return next
			}

			const id = this.$.$mol_state_arg.value( 'wordstat_task' ) ?? ''
			return this.tasks().some( task => task.id === id ) ? id : ''
		}

		task_rows() {
			return this.tasks_filtered().map( task => this.Task_link( task.id ) )
		}

		search_showed() {
			return this.tasks().length >= 10
		}

		tasks_filtered() {
			if( !this.search_showed() ) return this.tasks()
			const query = this.filter().trim().toLowerCase()
			if( !query ) return this.tasks()
			return this.tasks().filter( task => task.title.toLowerCase().includes( query ) )
		}

		@ $mol_action
		task_open( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.$.$shm_wordstat_perf.start( id )
			return next
		}

		default_settings() {
			const state = new this.$.$shm_wordstat_filter_state_store()
			return {
				queries: '',
				regions: 'Все',
				period_kind: 'PERIOD_MONTHLY',
				period_kinds: state.default_period_kinds(),
				devices: state.default_devices(),
			}
		}

		task_title_next() {
			const used = new Set( this.tasks().map( task => task.title.trim() ) )
			for( let index = 1; ; ++ index ) {
				const title = `Задача ${ index }`
				if( !used.has( title ) ) return title
			}
		}

		task_arg( id: string ) {
			return {
				section: 'wordstat',
				wordstat_task: id || null,
				wordstat_mode: null,
				wordstat_filter_id: this.task_filter_id( id ),
				dashboard: null,
				report: null,
				ba_filter_id: null,
			}
		}

		tasks_arg() {
			return this.task_arg( '' )
		}

		tasks_uri() {
			return new this.$.$mol_state_arg( this.List_head().Title().state_key() ).link( this.tasks_arg() )
		}

		task_filter_id( id: string ) {
			if( !id || id === this.new_task_id() ) return null
			return this.$.$mol_state_local.value< string >( `hitalama_wordstat_filter_last:${ id }` ) || null
		}

		task_uri( id: string ) {
			return new this.$.$mol_state_arg( this.Task_link( id ).state_key() ).link( this.task_arg( id ) )
		}

		new_task_arg() {
			return this.task_arg( this.new_task_id() )
		}

		new_task_current() {
			return this.task_current( this.new_task_id() )
		}

		@ $mol_action
		task_add_new( next?: Event ) {
			if( next === undefined ) return null

			const user = this.user_id()
			if( !user ) throw new Error( 'Войди в аккаунт для создания задачи Wordstat' )

			const record = this.$.$shm_ba_pb.create_record( 'wordstat_tasks', {
				user,
				title: this.task_title_next(),
				sort: this.task_sort_next(),
				mode: 'edit',
				settings: this.default_settings(),
			} )

			this.$.$mol_state_local.value( `hitalama_wordstat_task_mode:${ record.id }`, 'edit' )
			this.$.$mol_state_arg.value( 'section', 'wordstat' )
			this.$.$mol_state_arg.value( 'wordstat_task', record.id )
			this.$.$mol_state_arg.value( 'wordstat_mode', null )
			this.$.$mol_state_arg.value( 'wordstat_filter_id', null )
			this.focus_queries( next )

			return next
		}

		task_title( id: string ) {
			if( id === this.new_task_id() ) return 'Добавить задачу'
			return this.tasks().find( task => task.id === id )?.title ?? id
		}

		@ $mol_mem
		new_task_title( next?: string ) {
			return next ?? 'Задача'
		}

		task_title_current( next?: string ) {
			const id = this.task_id()
			if( id === this.new_task_id() ) return this.new_task_title( next )
			if( !id ) return next ?? ''
			if( next !== undefined ) {
				const title = next.trim() || this.task_title( id )
				this.$.$shm_ba_pb.update_record( 'wordstat_tasks', id, { title } )
				return title
			}
			return this.task_title( id )
		}

		task_current( id: string ) {
			return this.task_id() === id
		}

		task_add( id: string ) {
			return id === this.new_task_id()
		}

		task_sort_next() {
			return this.task_records().reduce(
				( max, task )=> Math.max( max, Number( task.sort ?? 0 ) ),
				0,
			) + 10
		}

	}

}
